export default function Button({ children, className, ...props }) {
  return (
    <button
      {...props}
      className={
        "px-4 py-2 rounded-lg bg-primary text-cream hover:bg-black transition shadow-sm disabled:opacity-60 disabled:cursor-not-allowed " +
        className
      }
    >
      {children}
    </button>
  );
}
